
import { Component, Emit, Vue } from 'vue-property-decorator';

import { Views } from '@/enums';
import UserModule from '@/store/modules/user';

@Component
export default class Rewards extends Vue {
  get isLoggedIn() {
    return UserModule.loggedIn;
  }

  get progress() {
    // TODO~> protect more here? or in getters...
    const percentage = (UserModule.currentPoints / (UserModule.currentPoints + UserModule.pointsUntilReward)) * 100;
    return `${percentage}%`;
  }

  get pointsUntilReward() {
    return UserModule.pointsUntilReward;
  }

  @Emit('show-login')
  handleClick(ev) {
    return ev;
  }

  get showComponent() {
    return ![Views.CHECKOUT].includes(this.$route.name as Views);
  }
}
